const FILTER_COLORS = {
  categories: 'bg-teal-400/20 text-teal-500',
  qualities: 'bg-blue-400/20 text-blue-500',
  interests: 'bg-purple-400/20 text-purple-500',
  study_levels: 'bg-orange-400/20 text-orange-500'
};

const SELECTD_LABEL_COLORS = {
  categories: 'text-teal-500',
  qualities: 'text-blue-500',
  interests: 'text-purple-500',
  study_levels: 'text-orange-500'
};

const FILTER_LABEL  = {
  categories: 'secteur',
  qualities: 'qualité',
  interests: 'intérêt',
  study_levels: 'niveau'
};

const FILTER_LABEL_LONG  = {
  categories: 'secteurs',
  qualities: 'qualités',
  interests: 'centres d\'intérêt',
  study_levels: 'niveaux d\'études'
};

const FilterSummaryBar = ({ selectedFilters, filters, activeFilter, onClearAll, onClearFilter }) => {
  const entries = Object.entries(selectedFilters)
    .filter(([_, list]) => list.length > 0);

  const totalSelections = entries.reduce((acc, [_, list]) => acc + list.length, 0);
  const currentSelection = selectedFilters[activeFilter].length
  return (
    <div className="w-full">
      <div className="flex justify-between items-center text-sm text-gray-300 mb-2 pl-1">
        <span>
          {filters[activeFilter].filter((filter) => filter.jobCount != 0).length} {FILTER_LABEL_LONG[activeFilter]} disponibles
          {<span className="whitespace-nowrap"> •{' '}<span className={`${SELECTD_LABEL_COLORS[activeFilter]} font-semibold`}>{currentSelection} sélectionné{activeFilter == 'qualities' ? 'e' : ''}{currentSelection > 1 ? 's' : ''}</span></span>}
        </span>
        {totalSelections > 0 && (
          <button onClick={onClearAll} className="whitespace-nowrap text-gray-400 hover:underline text-xs ml-5 bg-gray-800 px-2 py-1 rounded">
            ✕ Réinitialiser
          </button>
        )}
      </div>

      {totalSelections > 0 && (
        <div className="bg-gray-800 p-2 rounded-lg flex flex-wrap gap-2 text-xs">
          {entries.map(([group, list]) => (
            <div
              key={group}
              className={`px-2 py-1 rounded text-sm font-medium text-xs ${FILTER_COLORS[group]}`}
            >
              {list.length} {FILTER_LABEL[group]}
              {list.length > 1 ? (group === 'study_levels' ? 'x' : 's') : ''}
              <button onClick={() => onClearFilter(group)} className={`whitespace-nowrap ${SELECTD_LABEL_COLORS[group]} hover:underline text-xs pl-2 rounded`}>
                ✕
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
  
  export default FilterSummaryBar;
  